module.exports = __webpack_public_path__ + "fonts/Vazir.e4c3d56.eot";